import {
  vArray,
  vBoolean,
  vCurrency,
  vDate,
  vNonEmptyString,
  vNumber,
  vObject,
  vObjectId,
  vOptional,
  type vOutput,
  vPicklist,
} from '../validation/index.ts'
import { updateChargeSchema } from './quote.ts'

export const loadSaltResponseSchema = vObject({
  loadId: vObjectId(),
  carrierId: vNonEmptyString(),
  carrierName: vNonEmptyString(),
  amount: vNumber(),
  currency: vCurrency(),
  bookedDate: vOptional(vDate()),
  charges: vOptional(vArray(updateChargeSchema)),
  isRequested: vBoolean(),
})

export type LoadSaltResponse = vOutput<typeof loadSaltResponseSchema>

export const loadSaltStatuses = [
  'unavailable',
  'requested',
  'dismissed',
] as const
export type LoadSaltStatus = (typeof loadSaltStatuses)[number]

export const loadSaltResults = ['approved', 'declined'] as const
export type LoadSaltResult = (typeof loadSaltResults)[number]

export const loadSaltDetailsSchema = vObject({
  referenceLoadId: vOptional(vObjectId()),
  carrierId: vOptional(vNonEmptyString()),
  amount: vOptional(vNumber()),
  currency: vOptional(vCurrency()),
  status: vOptional(vPicklist(loadSaltStatuses)),
  result: vOptional(vPicklist(loadSaltResults)),
})

export type LoadSaltDetails = vOutput<typeof loadSaltDetailsSchema>

export const saltDetailsSchema = vObject({
  referenceLoadId: vObjectId(),
  amount: vNumber(),
  currency: vCurrency(),
  bookedDate: vOptional(vDate()),
  charges: vOptional(vArray(updateChargeSchema)),
  carrierName: vNonEmptyString(),
})

export type SaltDetails = vOutput<typeof saltDetailsSchema>
